/**
 * Created by Rodrigo Quesada on 31/03/17.
 */
import {formatMonthYear, toOrderValue} from '../../../shared/utils';
import {AbmsBoardEntry, AoaBoardEntry} from '../model/cv.model';
import {AbpsBoard} from '../../../../domain/model/licenses-certifications/board/abps/abps-board.model';
import {AbmsBoardSubspecialty} from '../../../../domain/model/licenses-certifications/board/abms/subspecialty/abms-board-subspecialty.model';
import {AoaBoardSubspecialty} from '../../../../domain/model/licenses-certifications/board/aoa/subspecialty/aoa-board-subspecialty.model';

//region Other Classes
export type BoardAffiliationType = AbmsBoardEntry | AbpsBoard | AoaBoardEntry;

export enum BoardAffiliationTypeId {
    ABMS = 1, ABPS, AOA
}

abstract class BoardAffiliationEntryData {
    type: BoardAffiliationTypeId;
    name?: string;
    certificationDate?: string;
    recertificationDate?: string;
    subspecialties: BoardAffiliationEntryData[] = [];

    constructor(boardAffiliationType: BoardAffiliationEntryType<any>) {
        this.type = boardAffiliationType.id;
    }
}

abstract class BoardAffiliationEntryType<T extends BoardAffiliationType> {

    constructor(readonly id: BoardAffiliationTypeId, private readonly _modelType: new () => T) {
    }

    isType(model: BoardAffiliationType): model is T { return model instanceof this._modelType; }

    abstract toEntryData(model: T): Partial<BoardAffiliationEntryData>

    abstract orderValueFor(model: T): number
}

class AbmsBoardAffiliationEntryType extends BoardAffiliationEntryType<AbmsBoardEntry> {

    constructor() { super(BoardAffiliationTypeId.ABMS, AbmsBoardEntry); }

    toEntryData(model: AbmsBoardEntry): Partial<BoardAffiliationEntryData> {
        const main = model.main;

        return {
            name: main.certificate,
            certificationDate: formatMonthYear(main.certificationDate),
            recertificationDate: formatMonthYear(main.recertificationDate),
            subspecialties: model.subspecialties
                .map(it => new BoardAffiliationEntry(it))
                .sort((a, b) => a.compareTo(b))
        };
    }

    orderValueFor(model: AbmsBoardEntry): number { return toOrderValue(model.main.certificationDate); }
}

class AbmsBoardSubspecialtyAffiliationEntryType extends BoardAffiliationEntryType<AbmsBoardSubspecialty> {

    constructor() { super(BoardAffiliationTypeId.ABMS, AbmsBoardSubspecialty); }

    toEntryData(model: AbmsBoardSubspecialty): Partial<BoardAffiliationEntryData> {
        return {
            name: model.certificate,
            certificationDate: formatMonthYear(model.certificationDate),
            recertificationDate: formatMonthYear(model.recertificationDate)
        };
    }

    orderValueFor(model: AbmsBoardSubspecialty): number { return toOrderValue(model.certificationDate); }
}

class AbpsBoardAffiliationEntryType extends BoardAffiliationEntryType<AbpsBoard> {

    constructor() { super(BoardAffiliationTypeId.ABPS, AbpsBoard); }

    toEntryData(model: AbpsBoard): Partial<BoardAffiliationEntryData> {

        return {
            name: model.certificate,
            certificationDate: formatMonthYear(model.certificationDate),
            recertificationDate: formatMonthYear(model.recertificationDate)
        };
    }

    orderValueFor(model: AbpsBoard): number { return toOrderValue(model.certificationDate); }
}

class AoaBoardAffiliationEntryType extends BoardAffiliationEntryType<AoaBoardEntry> {

    constructor() { super(BoardAffiliationTypeId.AOA, AoaBoardEntry); }

    toEntryData(model: AoaBoardEntry): Partial<BoardAffiliationEntryData> {
        const main = model.main;

        return {
            name: main.certificate,
            certificationDate: formatMonthYear(main.certificationDate),
            recertificationDate: formatMonthYear(main.recertificationDate),
            subspecialties: model.subspecialties
                .map(it => new BoardAffiliationEntry(it))
                .sort((a, b) => a.compareTo(b))
        };
    }

    orderValueFor(model: AoaBoardEntry): number { return toOrderValue(model.main.certificationDate); }
}

class AoaBoardSubspecialtyAffiliationEntryType extends BoardAffiliationEntryType<AoaBoardSubspecialty> {

    constructor() { super(BoardAffiliationTypeId.AOA, AoaBoardSubspecialty); }

    toEntryData(model: AoaBoardSubspecialty): Partial<BoardAffiliationEntryData> {
        return {
            name: model.certificate,
            certificationDate: formatMonthYear(model.certificationDate),
            recertificationDate: formatMonthYear(model.recertificationDate)
        };
    }

    orderValueFor(model: AoaBoardSubspecialty): number { return toOrderValue(model.certificationDate); }
}
//endregion

const boardAffiliationTypes: BoardAffiliationEntryType<any>[] = [
    new AbmsBoardAffiliationEntryType(),
    new AbmsBoardSubspecialtyAffiliationEntryType(),
    new AbpsBoardAffiliationEntryType(),
    new AoaBoardAffiliationEntryType(),
    new AoaBoardSubspecialtyAffiliationEntryType(),
];

export class BoardAffiliationEntry extends BoardAffiliationEntryData {

    private _orderValue: number;

    constructor(boardAffiliation: BoardAffiliationType) {
        const boardAffiliationType = boardAffiliationTypes.find(it => it.isType(boardAffiliation))!;
        super(boardAffiliationType);

        Object.assign(this, boardAffiliationType.toEntryData(boardAffiliation));

        this._orderValue = boardAffiliationType.orderValueFor(boardAffiliation);
    }

    compareTo(other: BoardAffiliationEntry) {
        //reverse order from latest/null to oldest
        return -(this._orderValue - other._orderValue);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/cv/download/document/board-affiliation-entry.class.ts